<template>
  <div :class="variant === 'row' ? 'intake-card__title-row' : 'intake-card__title'">
    <span class="intake-card__title-text">{{ title }}</span>
    <slot />
    <span v-if="invalid" class="intake-card__alert">
      <v-icon size="14">mdi-alert-circle-outline</v-icon>
      Needs attention
    </span>
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, required: true },
  invalid: { type: Boolean, default: false },
  variant: { type: String, default: "title", validator: (v) => ["title", "row"].includes(v) },
});
</script>
